import React from 'react';

import SEOContent from './SEOContent';
import RatingTable from './RatingTable';

import { ChakraProvider } from '@chakra-ui/react'
import { Container } from '@chakra-ui/react'
import { Flex, Heading, Text } from '@chakra-ui/react'
import {
  extendTheme,
  withDefaultColorScheme,
  theme as baseTheme,
} from '@chakra-ui/react'

import "./App.css";


const BODY_FONT = `'Manrope', 'Twemoji Country Flags', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`;
const DISPLAY_FONT = `'Fraunces', 'Manrope', Georgia, serif`;

const customTheme = extendTheme(
  {
    styles: {
      global: {
        // styles for the `body`
        body: {
          bg: 'white',
          color: 'black.100',
        },
      },
    },
    colors: {
      primary: baseTheme.colors.black,
    },
    fonts: {
      body: BODY_FONT,
      heading: DISPLAY_FONT,
    }
  },
  withDefaultColorScheme({ colorScheme: 'primary' }),
)

function App() {
  return (
    <ChakraProvider theme={customTheme}>
      <Container as="main" maxW="container.xl" marginTop={3} padding={{ base: 0, sm: 4 }}>
        <header className="seo-hero">
          <Flex align="baseline" gap={0}>
            <Text
              as="span"
              className="site-name"
              fontFamily={DISPLAY_FONT}
              color="#1A1423"
            >
              Chart
            </Text>
            <Text
              as="span"
              className="site-name"
              fontFamily={DISPLAY_FONT}
              fontWeight="400"
              color="#7F1D1D"
            >
              .vin
            </Text>
          </Flex>
          <Heading
            as="h1"
            className="seo-title"
            fontFamily={DISPLAY_FONT}
            color="#1A1423"
          >
            Wine Vintage Charts
          </Heading>
          <Text className="seo-description">
            Compare wine vintage ratings by region, country, critic, and year. Browse average vintage
            charts for Bordeaux, Burgundy, Champagne, Tuscany, Rioja, Napa Valley, Barolo, Brunello,
            and other major wine regions.
          </Text>
        </header>
        <RatingTable />
        <SEOContent />
        <footer className="site-footer">
          <a href="/about.html">About</a>
          <a href="/privacy.html">Privacy</a>
        </footer>
      </Container>
    </ChakraProvider>
  );
}

export default App;
